import { useState } from "react";
import { Label } from "../../../components/ui/label";
import { ChevronDown, ChevronRight } from "lucide-react";

export const Section = ({ title, icon: Icon, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="bg-white border border-slate-200" data-testid={`section-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between p-4 hover:bg-slate-50 transition-colors"
        data-testid={`toggle-${title.toLowerCase().replace(/\s+/g, "-")}`}
      >
        <div className="flex items-center gap-3">
          <Icon className="w-5 h-5 text-[#FF5A1F]" />
          <span className="font-['Outfit'] font-semibold text-[#0F172A]">{title}</span>
        </div>
        {open ? <ChevronDown className="w-4 h-4 text-slate-400" /> : <ChevronRight className="w-4 h-4 text-slate-400" />}
      </button>
      {open && <div className="border-t border-slate-200 p-4 space-y-4">{children}</div>}
    </div>
  );
};

export const FieldRow = ({ label, sublabel, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
    <div className="sm:w-56 flex-shrink-0">
      <Label className="text-sm font-medium text-[#0F172A]">{label}</Label>
      {sublabel && <p className="text-xs text-slate-500">{sublabel}</p>}
    </div>
    <div className="flex-1 max-w-xs">{children}</div>
  </div>
);
